import {call, put} from "redux-saga/effects";
import {api} from "../../api/api";
import {SessionDto} from "../auth.interface";
import {authActions} from "../auth.slice";

export function* loadSessionSaga() {
    try {
        const session = (yield call(api.session)) as SessionDto;
        yield put(authActions.setSession(session.email));
    } catch {
        yield put(authActions.clearSession());
    }
}
